(ns ycweb.app.blitz.receiving.receiving
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.blitz.keepaside.keepaside :as keepaside]
   [ycweb.app.blitz.prereceiving.prereceiving :as prereceiving]
   [ycweb.app.blitz.unpacking.unpacking :as unpacking]
   [ycweb.app.pos.menu :as menu]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.header :as header]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.sound :as sound]))

(def ibt-steps
  (forms/setup-steps
    [{:key :choose-type :title "Receiving Type"}
     {:key :packbox-list :title "List of Packboxes to Receive"}
     {:key :packbox :title "Scan Packbox"}
     {:key :location :title "Scan Location"}
     {:key :choose-method :title "Choose Check Method"}
     {:key :packbox-confirm :title "Count Items"}
     {:key :items :title "Processed Items"}
     {:key :choose-close-method :title "Choose Close Method"}
     {:key :confirm :title "Confirm Items"}
     {:key :finished :title "Done"}]))

(def ycs-steps
  (forms/setup-steps
    [{:key :choose-type :title "Receiving Type"}
     {:key :stockorder :title "Scan YCS"}
     {:key :stockorder-details :title "Enter YCS Details"}
     {:key :location :title "Scan Location"}
     {:key :items :title "Processed Items"}
     {:key :choose-close-method :title "Choose Close Method"}
     {:key :confirm :title "Confirm Items"}
     {:key :review-missing :title "Review Missing Items"}
     {:key :finished :title "Done"}]))

(def keepaside-steps
  (forms/setup-steps
    [{:key :choose-type :title "Receiving Type"}
     {:key :locations :title "Locations"}
     {:key :item-scan :title "Items"}
     {:key :tolocation :title "Scan Shelf"}
     {:key :items :title "Item"}]))

(rum/defc screen-wrapper [app-atom {:keys [modal-fn]} steps progress-step body foot-note call-to-action]
  [:div.page-body
   (header/header app-atom "Receiving" {})
   (header/menu-overlay (rum/cursor app-atom :menu))
   (header/menu app-atom (menu/select-menus app-atom))
   (into
     [:div.page-body__main-content
      (when modal-fn
        [:nav.section.button-bar
         (buttons/button
           " Options"
           #(modal-fn app-atom)
           {:icon-right :dots-menu-horizontal :muted true :text-default true})])
      [:div.section
       (forms/progress-steps
         (forms/progress-step steps progress-step))]]
     body)
   (into
     [:aside.page-body__footer]
     foot-note)
   call-to-action])

(defn transition-stockorder [app-atom]
  (swap! app-atom assoc-in [:receiving :stockorderref] nil)
  (t/transition-next app-atom :receiving/stockorder))

(defn scan-action [app-atom {:keys [items selected-destination]}]
  (cond
    (and items (empty? items))
    (do
      (grid/dispatch-action app-atom :receiving/list-keepaside {})
      (toaster/open-toast app-atom :success "Finished" {}))

    items
    (do
      (swap! app-atom assoc-in [:receiving :keepaside :items] items)
      (t/transition-next app-atom :receiving/list-items-keepaside))

    :else
    (do
      (swap! app-atom update-in [:receiving :keepaside] assoc
        :scanned (inc (get-in @app-atom [:receiving :keepaside :scanned]))
        :selected-destination selected-destination)
      (t/transition-next app-atom :receiving/selected-item-keepaside))))

(defmethod grid/action :receiving/selected-scan-keepaside [app-atom {:keys [scan]} _]
  (let [{:keys [fromlocation selected-item selected-destination]} (get-in @app-atom [:receiving :keepaside])]

    (cond
      (=
        selected-destination
        scan)
      (toaster/open-toast app-atom :error "Scan Item" {})

      (= (:barcode fromlocation) scan)
      (toaster/open-toast app-atom :error "Can't scan the same basket" {})

      (not= scan (:barcode selected-item))
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :receiving/scan-shelf-keepaside
          {:fromlocation-id (:id fromlocation)
           :tolocation-barcode scan
           :item-barcode (:barcode selected-item)}))

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :receiving/scan-shelf-keepaside
          {:fromlocation-id (:id fromlocation)
           :item-barcode (:barcode selected-item)
           :tolocation-barcode selected-destination})))))

(defmethod flow/barcode-dispatch-screen :receiving/selected-item-keepaside [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/selected-scan-keepaside {:scan scan}))

(rum/defc selected-item-view < rum/reactive [app-atom]
  (let [{:keys [fromlocation selected-item scanned selected-destination]} (cmn/curact app-atom [:receiving :keepaside])
        {:keys [features brand product qty images barcode]} selected-item]
    (w/wrapper app-atom "Receiving" {:steps keepaside-steps :step :items}
      [[:div.section
        [:h2.u-text-center.heading
         {:class (u/bem :heading [:standard :flush])}
         "Scan items and put onto shelf:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b selected-destination]
         [:span.heading__subtext
          "Trolley: " [:b (:name fromlocation)]]]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn
         #(grid/dispatch-action app-atom :receiving/scan-basket-keepaside {:scan (:barcode fromlocation)})
         :right-plain true}))))

(defmethod flow/render-screen :receiving/selected-item-keepaside [app-atom screen]
  (selected-item-view app-atom))

(defmethod comms/receive :receiving/scan-shelf-keepaside [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (scan-action app-atom e))

(defmethod grid/action :receiving/scan-shelf-keepaside [app-atom {:keys [scan]} _]
  (let [{:keys [fromlocation selected-item]} (get-in @app-atom [:receiving :keepaside])]

    (cond
      (= (:barcode fromlocation) scan)
      (toaster/open-toast app-atom :error "Can't unpick to your own trolley" {})

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :receiving/scan-shelf-keepaside
          {:fromlocation-id (:id fromlocation)
           :tolocation-barcode scan
           :item-barcode (:barcode selected-item)})))))

(defmethod flow/barcode-dispatch-screen :receiving/scan-shelf-keepaside [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/scan-shelf-keepaside {:scan scan}))

(rum/defc scan-shelf-keepaside < rum/reactive [app-atom]
  (let [{:keys [fromlocation scanned selected-item]} (cmn/curact app-atom [:receiving :keepaside])
        {:keys [features brand product dest qty images barcode]} selected-item]
    (w/wrapper app-atom "Receiving" {:steps keepaside-steps :step :tolocation}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan Keep Aside Shelf"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b dest]
         [:span.heading__subtext
          "To start receiving your items"]
         [:span.heading__subtext
          "From: " [:b (:name fromlocation)]]]]
       [:div.slats
        [:article.card
         {:class (u/bem :product-card [:is-disabled])}
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__footnote]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn
         #(grid/dispatch-action app-atom :receiving/scan-basket-keepaside
            {:scan (:barcode fromlocation)})
         :right-text "Scan Shelf"
         :right-plain true}))))

(defmethod flow/render-screen :receiving/scan-shelf-keepaside [app-atom _]
  (scan-shelf-keepaside app-atom))

(defmethod grid/action :receiving/scan-item-keepaside [app-atom {:keys [scan]} _]
  (let [items (get-in @app-atom [:receiving :keepaside :items])
        selected-item
        (first
          (filter #(= scan (:barcode %)) items))]

    (cond
      (nil? selected-item)
      (toaster/open-toast app-atom :error "Item not found" {})

      :else
      (do
        (swap! app-atom update-in [:receiving :keepaside] assoc
          :selected-item selected-item
          :scanned 0)
        (t/transition-next app-atom :receiving/scan-shelf-keepaside)))))

(defmethod flow/barcode-dispatch-screen :receiving/list-items-keepaside [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/scan-item-keepaside {:scan scan}))

(rum/defc list-items-keepaside < rum/reactive [app-atom]
  (let [{:keys [items fromlocation]} (cmn/curact app-atom [:receiving :keepaside])]
    (w/wrapper app-atom "Receiving" {:steps keepaside-steps :step :item-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Item to start receiving"
         [:span {:class "heading__subtext"}
          "Location: " [:b (:barcode fromlocation)]]]]
       [:div.slats
        (map unpacking/item-slat items)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :receiving/list-keepaside {})
         :right-text "Scan Item"
         :right-plain true}))))

(defmethod flow/render-screen :receiving/list-items-keepaside [app-atom _]
  (list-items-keepaside app-atom))

(defmethod comms/receive :receiving/scan-basket-keepaside [app-atom {:keys [items fromlocation]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update-in [:receiving :keepaside] assoc
    :fromlocation fromlocation
    :items items)
  (t/transition-next app-atom :receiving/list-items-keepaside))

(defmethod grid/action :receiving/scan-basket-keepaside [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/scan-basket-keepaside
    {:scan scan}))

(defmethod flow/barcode-dispatch-screen :receiving/list-keepaside [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/scan-basket-keepaside {:scan scan}))

(rum/defc list-keepaside < rum/reactive [app-atom]
  (let [locations (cmn/curact app-atom [:receiving :keepaside :locations])]
    (w/wrapper app-atom "Keep Aside" {:steps keepaside-steps :step :locations}
      [[:div.section
        [:div.u-margin-top-24
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "List of Baskets"
          [:span.heading__subtext
           "to receive into the store"]]]]
       [[:div.slats
         (concat
           [[:h3.heading-slat
             {:class (u/bem :slat nil)}
             [:span.heading-slat__icon-wrapper
              [:i {:class (u/bem :icon [:block :barcode-scan])}]]
             [:span.heading-slat__text
              "Scan Basket to Move:"]]]
           (map keepaside/location-slat locations))]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Basket"
         :right-plain true}))))

(defmethod flow/render-screen :receiving/list-keepaside [app-atom _]
  (list-keepaside app-atom))

(defmethod comms/receive :receiving/list-keepaside [app-atom {:keys [locations]}]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:receiving :keepaside :locations] locations)
  (t/transition-next app-atom :receiving/list-keepaside))

(defmethod grid/action :receiving/list-keepaside [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading packboxes to receive" {})
  (comms/send :receiving/list-keepaside {}))

(rum/defc choose-type < rum/reactive [app-atom]
  (screen-wrapper app-atom {} ycs-steps :choose-type
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Choose Receiving Type"]
      [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :receiving/list-packboxes {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :truck-check :large :block])}]]
        [:span.tile__text "IBT Transfer"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
       {:on-click
        #(transition-stockorder app-atom)}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :stocktake :large :block])}]]
        [:span.tile__text "YCS Stockorder"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-mint-green-dark.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :receiving/list-keepaside {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :truck :large :block])}]]
        [:span.tile__text "Keep Aside"]]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-next app-atom :main-menu)
       :right-plain true})))

(defmethod flow/render-screen :receiving/choose-type [app-atom screen]
  (swap! app-atom assoc :receiving nil)
  (choose-type app-atom))

(defmethod grid/action :receiving/list-packboxes [app-atom _ _]
  (toaster/open-toast app-atom :processing "Loading packboxes to receive" {})
  (comms/send :receiving/list-packboxes {})
  (t/transition-next app-atom :receiving/list-packboxes))

(defmethod comms/receive :receiving/list-packboxes [app-atom {:keys [packbox-list packbox-count]}]
  (toaster/close-toast app-atom)
  (swap! app-atom update :receiving assoc
    :packbox-list packbox-list
    :packbox-count packbox-count))

(rum/defc list-packboxes < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        packbox-list (cmn/curact current-atom :packbox-list)
        packbox-count (cmn/curact current-atom :packbox-count)]
    (screen-wrapper app-atom {} ibt-steps :packbox-list
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str packbox-count " Packboxes to Receive")]]
       (into [:div.slats]
         (for [box packbox-list]
           [:article.slat.transfer-order-slat
            [:header.transfer-order-slat__header
             [:div.transfer-order-slat__title-wrapper
              [:h1.transfer-order-slat__title
               [:span.transfer-order-slat__order-no (str "PB-" (:id box))]
               [:span.transfer-order-slat__user
                (str (:itemqty box) " Items")]]]]]))]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :receiving/packbox)}))))

(defmethod flow/render-screen :receiving/list-packboxes [app-atom screen]
  (list-packboxes app-atom))

(defn location-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :receiving/location-menu-barcode}

      {:label "Cancel Session"
       :action :receiving/menu-cancel-session
       :style
       {:full true :large true :negative true
        :icon-left :warning :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :receiving/location-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :receiving/location-scan
     :input-key :scan
     :input-type :barcode}))

(rum/defc location-scan < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        steps
        (if (cmn/curact current-atom :stockorder)
          ycs-steps
          ibt-steps)]
    (screen-wrapper app-atom {:modal-fn location-modal} steps :location
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Location"]
        [:div
         [:i.u-block-center
          {:class
           (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Scan the location you're receiving to"]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :receiving/location [app-atom screen]
  (location-scan app-atom))

(defmethod flow/barcode-dispatch-screen :receiving/location [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/location-scan {:scan scan}))

(defmethod grid/action :receiving/location-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/location-scan
    {:scan scan
     :session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/location-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (cond
    (not (:location e))
    (toaster/open-toast app-atom :error "No location found" {})

    :else
    (do
      (t/transition-next app-atom
        (if (= :count-items (get-in @app-atom [:receiving :method]))
          :receiving/packbox-confirmation
          :receiving/item-list))
      (swap! app-atom update :receiving assoc
        :location (:location e)
        :allow-close? (:allow-close? e)
        :blind? (:blind? e)
        :items (:items e)))))

(defn packbox-modal [app-atom {:keys [unscan? location packbox-scan packbox-confirm packbox-items?]}]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :receiving/packbox-scan-menu-barcode}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :receiving/packbox-scan-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :receiving/packbox-scan
     :input-key :scan
     :input-type :barcode}))

(defn stockorder-modal [app-atom {:keys [unscan? location packbox-scan packbox-confirm packbox-items?]}]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :receiving/stockorder-scan-menu-barcode}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :receiving/stockorder-scan-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :receiving/stockorder-scan
     :input-key :scan
     :input-type :barcode}))

(rum/defc stockorder-scan < rum/reactive [app-atom]
  (screen-wrapper app-atom {:modal-fn stockorder-modal} ycs-steps :stockorder
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan YCS"]
      [:div
       [:i.u-block-center
        {:class
         (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]]

    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan the YCS to open it"]]]

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-plain true})))

(defmethod flow/render-screen :receiving/stockorder [app-atom screen]
  (stockorder-scan app-atom))

(defmethod flow/barcode-dispatch-screen :receiving/stockorder [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/stockorder-scan {:scan scan}))

(defmethod grid/action :receiving/stockorder-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/stockorder-scan {:scan scan}))

(defmethod comms/receive :receiving/stockorder-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :receiving/stockorder-details)
  (swap! app-atom update :receiving assoc
    :session-id (:session-id e)
    :item-count nil
    :method nil
    :stockorder (:stockorder e)
    :es-client-order (:clientorder e)))

(rum/defc packbox-scan < rum/reactive [app-atom]
  (screen-wrapper app-atom {:modal-fn packbox-modal} ibt-steps :packbox
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Packbox"]
      [:div
       [:i.u-block-center
        {:class
         (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]]

    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush])}
       "Scan the packbox"]]]

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-plain true})))

(defmethod flow/render-screen :receiving/packbox [app-atom screen]
  (packbox-scan app-atom))

(defmethod flow/barcode-dispatch-screen :receiving/packbox [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/packbox-scan {:scan scan}))

(defmethod grid/action :receiving/packbox-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/packbox-scan
    {:scan scan
     :location-id (get-in @app-atom [:receiving :location :id])}))

(defmethod comms/receive :receiving/packbox-scan-response [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (do
    (t/transition-next app-atom
      (if (:blind? e) :receiving/location :receiving/choose-method))
    (swap! app-atom update :receiving assoc
      :session-id (:session-id e)
      :item-count nil
      :method nil
      :blind? (:blind? e)
      :blind-discrepancy-items []
      :packbox (:packbox e)
      :stockorder (:stockorder e))))

(rum/defc choose-method < rum/reactive [app-atom]
  (let [method-atom (rum/cursor-in app-atom [:receiving :method])]
    (screen-wrapper app-atom {} ibt-steps :choose-method
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Check Items"]
        [:div.form-field
         (forms/radio "Scan Items" :scan-items method-atom {:description [:span "Scan each item individually " [:b "(preferred)"]]})]
        [:div.form-field
         (forms/radio "Count Items" :count-items method-atom {:description "Count items in box and give as number"})]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :receiving/location)}))))

(defmethod flow/render-screen :receiving/choose-method [app-atom screen]
  (choose-method app-atom))

(defn packbox-confirm-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :receiving/packbox-confirm-menu-barcode}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :receiving/packbox-confirm-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :receiving/packbox-items
     :input-key :scan
     :input-type :barcode}))

(rum/defc packbox-confirm < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        location (cmn/curact current-atom :location)]
    (screen-wrapper app-atom {:modal-fn packbox-confirm-modal} ibt-steps :packbox-confirm
      [[:div {:class (u/bem :section [:medium])}
        [:h2.u-text-center {:class (u/bem :heading [:standard])}
         "Number of Items"
         [:span.u-hidden-from-view " "]]

        (forms/input "" "e.g. 20" (rum/cursor current-atom :item-count)
          {:hint "Count the items in the box and enter just the number"
           :type :number})]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Enter item count for location " (:name location)]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (when (pos? (:item-count (cmn/curval current-atom)))
           #(grid/dispatch-action app-atom :receiving/packbox-confirm {}))}))))

(defmethod flow/render-screen :receiving/packbox-confirmation [app-atom screen]
  (packbox-confirm app-atom))

(defmethod flow/barcode-dispatch-screen :receiving/packbox-confirmation [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/packbox-items {:scan scan}))

(defmethod grid/action :receiving/packbox-items [app-atom {:keys [scan]} _]
  (if (= scan (get-in @app-atom [:receiving :packbox :barcode]))
    (t/transition-next app-atom :receiving/item-list)
    (toaster/open-toast app-atom :error "No packbox found" {})))

(defmethod grid/action :receiving/packbox-confirm [app-atom]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/packbox-confirm
    {:item-count (get-in @app-atom [:receiving :item-count])
     :location-id (get-in @app-atom [:receiving :location :id])
     :session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/packbox-confirm-response [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (if (not (:items e))
    (toaster/open-toast app-atom :error "No items found" {})
    (do
      (t/transition-next app-atom :receiving/item-list)
      (swap! app-atom update :receiving assoc
        :allow-close? (:allow-close? e)
        :items (:items e)))))

(defmethod grid/modal-config :receiving/modal-create-cb [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :receiving/menu-create-cb [app-atom config _]
  (grid/open-modal app-atom :receiving/modal-create-cb
    {:scan ""
     :config
     {:title "Create CB"
      :field-text "Printer Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :receiving/create-cb
      :input-key :manual-scan
      :input-type :barcode}}))

(defmethod flow/barcode-dispatch-modal :receiving/modal-create-cb [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :receiving/create-cb {:modal-scan scan}))

(defmethod grid/action :receiving/create-cb [app-atom {:keys [modal-scan manual-scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/create-cb
    {:scan (or modal-scan manual-scan)
     :session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/create-cb [app-atom e]
  (toaster/open-toast app-atom :success "CB Created." {}))

(defn item-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Create CB"
       :action :receiving/menu-create-cb}

      {:label "Unscan Product"
       :action :receiving/menu-unscan
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Manual Barcode"
       :action :receiving/item-menu-barcode}

      {:label "Cancel Session"
       :action :receiving/menu-cancel-session
       :style
       {:full true :large true :negative true
        :icon-left :warning :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :receiving/item-menu-details [app-atom config _]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        {:keys [barcode lengthcm widthcm heightcm weightkg]} (cmn/curact current-atom :modal-item-details)]
    (grid/multi-input-modal app-atom
      {:title "Update details"
       :save-key :receiving/item-update-details
       :save-text "Update"
       :inputs
       [{:field-text "Barcode"
         :initial-value barcode
         :input-key :details-barcode
         :input-type :string}
        {:field-text "Length (cm)"
         :initial-value lengthcm
         :input-key :details-length
         :input-type :number}
        {:field-text "Width (cm)"
         :initial-value widthcm
         :input-key :details-width
         :input-type :number}
        {:field-text "Height (cm)"
         :initial-value heightcm
         :input-key :details-hight
         :input-type :number}
        {:field-text "Weight (kg)"
         :initial-value weightkg
         :input-key :details-weight
         :input-type :number}]})))

(defmethod grid/action :receiving/item-update-details [app-atom new-details _]
  (let [{:keys
         [details-barcode
          details-length
          details-width
          details-hight
          details-weight]} new-details
        item-details (get-in @app-atom [:receiving :modal-item-details])]

    (toaster/open-subtle-progress app-atom)
    (comms/send :receiving/item-update-details
      {:session-id (get-in @app-atom [:receiving :session-id])
       :item-details
       {:uuid (:uuid item-details)
        :barcode details-barcode
        :lengthcm details-length
        :widthcm details-width
        :heightcm details-hight
        :weightkg details-weight}})))

(defmethod comms/receive :receiving/item-update-details [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:receiving :items] (:items e)))

(defmethod grid/modal-config :receiving/modal-item-print [_ _ _]
  {:body grid/multi-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :receiving/item-menu-print [app-atom config _]
  (grid/multi-input-modal app-atom
    {:title "Print"
     :save-key :receiving/item-print
     :save-text "Capture"
     :modal-type :receiving/modal-item-print
     :inputs
     [{:field-text "Number of barcodes"
       :initial-value 1
       :input-key :qty
       :input-type :number}
      {:field-text "Printer barcode"
       :initial-value ""
       :input-key :manual-scan
       :input-type :barcode}]}))

(defmethod flow/barcode-dispatch-modal :receiving/modal-item-print [_ app-atom scan]
  (toaster/open-subtle-progress app-atom)
  (grid/dispatch-modal-action app-atom :receiving/item-print
    {:modal-scan scan}))

(defmethod grid/action :receiving/item-print [app-atom {:keys [modal-scan manual-scan qty]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/item-print
    {:session-id (get-in @app-atom [:receiving :session-id])
     :scan (or modal-scan manual-scan)
     :item (get-in @app-atom [:receiving :modal-item])
     :qty qty}))

(defmethod comms/receive :receiving/item-print [app-atom e]
  (toaster/open-toast app-atom :success "Barcode Printed." {}))

(defmethod grid/action :receiving/item-menu-qty [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual qty"
     :field-text "Qty"
     :initial-value ""
     :save-text "Capture"
     :save-key :receiving/item-scan
     :input-key :manual-qty
     :input-type :number}))

(defmethod grid/action :receiving/item-modal [app-atom item]
  (toaster/open-toast app-atom :processing "Loading item" {})
  (comms/send :receiving/item-modal
    {:item item
     :session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/item-modal [app-atom {:keys [item item-details] :as e}]
  (toaster/close-toast app-atom)
  (grid/menu-modal app-atom
    {:items
     [{:label "Details"
       :action :receiving/item-menu-details}

      {:label "Print"
       :action :receiving/item-menu-print}

      {:label "Manual Qty"
       :action :receiving/item-menu-qty}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]})
  (swap! app-atom update :receiving assoc
    :modal-item-details item-details
    :modal-item item))

(defmethod grid/action :receiving/menu-unscan [app-atom config _]
  (grid/open-modal app-atom :receiving/modal-item-unscan
    {:scan ""
     :config
     {:title "Unscan Product"
      :field-text "Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :receiving/item-unscan
      :input-key :manual-scan
      :input-type :barcode}}))

(defmethod grid/modal-config :receiving/modal-item-unscan [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod flow/barcode-dispatch-modal :receiving/modal-item-unscan [_ app-atom scan]
  (grid/dispatch-modal-action app-atom :receiving/item-unscan {:modal-scan scan}))

(defmethod grid/action :receiving/item-unscan [app-atom {:keys [modal-scan manual-scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/item-scan
    {:scan (or modal-scan manual-scan)
     :unscan? true
     :location-id (get-in @app-atom [:receiving :location :id])
     :session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod grid/action :receiving/item-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :receiving/item-scan
     :input-key :scan
     :input-type :barcode}))

(defmethod grid/action :receiving/menu-cancel-session [app-atom config _]
  (grid/confirm-modal app-atom
    {:title "Cancel Session"
     :text [:p {:class (u/bem :paragraph [:flush])}
            "Are you sure you want to cancel your session and revert all of your scans?"]
     :confirm-key :receiving/cancel-session
     :confirm-text "Yes" :icon-left :delete :icon-class :3-2 :negative true}))

(defmethod grid/action :receiving/cancel-session [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/cancel-session
    {:session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/cancel-session [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (do
    (t/transition-next app-atom :receiving/location)
    (swap! app-atom assoc-in [:receiving :session-id] (:session-id e))))

(rum/defc item-slat < rum/reactive
  [{:keys [barcode product code itemtype qty qtyscanned missing-details bulk-ownbox]}
   {:keys [on-click blind?]}]
  (let [qtyscanned (or qtyscanned 0)

        [slat-color slat-bg-color]
        (if blind?
          (when (pos? qtyscanned) [:success :success-bg])
          (cond
            missing-details [:warning :warning-bg]
            (= qtyscanned qty) [:success :success-bg]
            (> qtyscanned qty) [:error :error-bg]
            (pos? qtyscanned) [:warning :warning-bg]))]

    [:article.slat.product-slat.transfer-product-slat
     {:class (u/bem :slat [slat-color slat-bg-color]) :on-click on-click}
     [:div.product-slat__qty.transfer-product-slat__qty
      [[:div.transfer-product-slat__count
        [:b (if (and (not blind?) (zero? qtyscanned))
              {:class "u-text-status-negative"}
              {})
         qtyscanned]
        (when-not blind?
          [:span [:span.u-pipe "of"] [:span qty]])]
       [:div.transfer-product-slat__icon-wrapper
        [:i {:class (u/bem :icon [:block slat-color :3-3])}]]]]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1.product-slat__title
         [:span.product-slat__brand itemtype]
         product]]]
      [:ul.product-slat__details
       [:li.product-slat__barcode
        [:b.u-text-spaced-1 barcode]]
       [:li.product-slat__barcode
        [:b.u-text-spaced-1 code]]]
      (when (and missing-details (not blind?))
        [:ul.product-slat__details
         [:li.product-slat__barcode
          [:b.u-text-status-negative "Missing Details"]]])
      (when (and bulk-ownbox (not blind?))
        [:ul.product-slat__details
         [:li.product-slat__barcode
          [:b.u-text-status-negative "Own Box Product"]]])]]))

(rum/defc item-list < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        device (rum/cursor-in app-atom [:device])
        items (cmn/curact current-atom :items)
        scanned-items (filter (comp pos? :qtyscanned) items)
        packbox (cmn/curact current-atom :packbox)
        location (cmn/curact current-atom :location)
        scroll (cmn/curact device :scroll)
        blind? (cmn/curact current-atom :blind?)

        allow-close? (cmn/curact current-atom :allow-close?)
        allow-next? (or blind? (empty? (filter true? (map :missing-details scanned-items))))
        stockorder (cmn/curact current-atom :stockorder)
        [steps date-started]
        (if stockorder
          [ycs-steps (:dateprereceived stockorder)]
          [ibt-steps (:dateadded packbox)])

]

    (screen-wrapper app-atom {:modal-fn item-list-modal} steps :items
      [(if (and blind? (empty? items))
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "Start Scanning"
           [:span.u-hidden-from-view " - "]
           [:div
            [:span.heading__subtext "Scan items for location " (:name location)]]]
          [:div
           [:i.u-block-center
            {:class (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]
         [:div
          {:class (u/bem :section [:medium])}
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           (if blind?
             (str "Scanned: " (count scanned-items) " items")
             (str "Progress: " (count scanned-items) " / " (count items)))
           [:span.u-hidden-from-view " - "]
           [:div
            [:span.heading__subtext "Started " (u/format-date :long-date date-started)]
            [:span.heading__subtext "Scan items for location " (:name location)]]]])
       [:div.slats
        (map
          (fn [i]
            (rum/with-key
              (item-slat i
                {:blind? blind?
                 :on-click
                 #(grid/dispatch-action app-atom
                    :receiving/item-modal i)})
              (:barcode i)))
          items)]]
      [(when (> (:y scroll) 181)
         [:div {:class (u/bem :persistent-hint [:is-visible])}
          [:span {:class (u/bem :pill [:is-sentencecase :light])}
           "Scan items for location " (:name location)]])]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Next"
         :right-fn
         (cond
           (not allow-next?)
           nil

           blind?
           #(t/transition-next app-atom :receiving/blind-discrepancy)

           allow-close?
           #(t/transition-next app-atom :receiving/choose-close-method)

           :else
           #(t/transition-next app-atom :receiving/confirm))}))))

(defmethod flow/render-screen :receiving/item-list [app-atom screen]
  (item-list app-atom))

(rum/defc choose-close-method < rum/reactive
  [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        blind? (cmn/curact current-atom :blind?)
        steps
        (if (cmn/curact current-atom :stockorder)
          ycs-steps
          ibt-steps)]
    (screen-wrapper app-atom {} steps :choose-close-method
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Choose Close Method"]
        [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
         {:on-click
          #(t/transition-next app-atom
             (if blind? :receiving/blind-discrepancy :receiving/confirm))}
         [:span.tile__content
          [:span.tile__icon-wrapper
           [:i.tile__icon
            {:class (u/bem :icon [:2-2 :pencil :large :block])}]]
          [:span.tile__text "Confirm session"]]]
        [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
         {:on-click
          #(grid/dispatch-action app-atom :receiving/close-location {})}
         [:span.tile__content
          [:span.tile__icon-wrapper
           [:i.tile__icon
            {:class (u/bem :icon [:2-2 :location :large :block])}]]
          [:span.tile__text "Close location"]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod grid/action :receiving/close-location [app-atom config _]
  (toaster/open-toast app-atom :processing "Closing location" {})
  (comms/send :receiving/close-location
    {:session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/close-location [app-atom {:keys [packbox-list] :as e}]
  (toaster/close-toast app-atom)
  (do
    (t/transition-next app-atom :receiving/location)
    (swap! app-atom assoc-in [:receiving :session-id] (:session-id e))))

(defmethod flow/render-screen :receiving/choose-close-method [app-atom screen]
  (choose-close-method app-atom))

(defmethod flow/barcode-dispatch-screen :receiving/item-list [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/item-scan {:scan (str/trim scan)}))

(defmethod grid/action :receiving/item-scan [app-atom {:keys [scan manual-qty warning]} _]
  (let [valid-scan (or scan (get-in @app-atom [:receiving :modal-item :barcode]))]
    (cond
      (not (u/presence valid-scan))
      (toaster/open-toast app-atom :error "Empty scan. Please try again." {})

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :receiving/item-scan
          {:scan valid-scan
           :manual-qty manual-qty
           :unscan? false
           :location-id (get-in @app-atom [:receiving :location :id])
           :session-id (get-in @app-atom [:receiving :session-id])})))))

(defmethod comms/receive :receiving/item-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (:warning e) (toaster/open-toast app-atom :warning (:warning e) {}))
  #?(:cljs (.scrollTo js/window 0 0))
  (if (not (:items e))
    (toaster/open-toast app-atom :error "No items found" {})
    (swap! app-atom update :receiving assoc
      :allow-close? (:allow-close? e)
      :items (:items e))))

(rum/defc review-missing-slat < rum/reactive
  [{:keys [barcode product code itemtype missing barcode-missing barcode-incorrect
           barcode-not-scanning expired damaged incorrect-product notinvoiced saved?
           expiring nopackaging]}
   {:keys [on-click]}]
  [:article.slat.product-slat.transfer-product-slat
   {:class (u/bem :slat (if saved? [:success :success-bg] [:error :error-bg])) :on-click on-click}
   [:div.product-slat__info
    {:style {:overflow-x "scroll" :flex-wrap "nowrap"}}
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h1.product-slat__title
       [:span.product-slat__brand itemtype]
       product]]]
    [:ul.product-slat__details
     [:li.product-slat__barcode
      [:b.u-text-spaced-1 barcode]]
     [:li.product-slat__barcode
      [:b.u-text-spaced-1 code]]]
    [:ul.product-slat__details
     (map
       (fn [[display qty]]
         [:li.product-slat__barcode
          [:b.u-text-spaced-1 [:b.u-text-status-negative (str display ": ") qty]]])
       [["Ordered Not Invoiced" notinvoiced]
        ["Here Barcode Missing" barcode-missing]
        ["Here Barcode Incorrect" barcode-incorrect]
        ["Here Barcode Not Scanning" barcode-not-scanning]
        ["Here Expired" expired]
        ["Here Damaged" damaged]
        ["Here Incorrect Product" incorrect-product]
        ["Missing" missing]
        ["Here Expiring Soon" expiring]
        ["Here No Packaging" nopackaging]])]]])

(rum/defc missing-modal-body < rum/reactive [app-atom config-atom]
  (let [{:keys [missing notinvoiced barcode-missing barcode-incorrect barcode-not-scanning expired
                damaged incorrect-product remaining expiring nopackaging]}
        (cmn/curact config-atom [:config :item])

        error
        (when
          (or
            (> missing remaining)
            (> barcode-missing remaining)
            (> barcode-incorrect remaining)
            (> expired remaining)
            (> barcode-not-scanning remaining)
            (> damaged remaining)
            (> incorrect-product remaining)
            (> notinvoiced remaining)
            (> expiring remaining)
            (> nopackaging remaining))
          (str "Maximum amount of " remaining " exceeded."))
        hint (or error (str "Max amount is " remaining))]
    [:div
     [:h3
      {:class (u/bem :heading [:medium-large])}
      "Missing Items"]
     (map
       (fn [[display lkey]]
         (forms/input (str display ":") "" (rum/cursor-in config-atom [:config :item lkey])
           {:hint hint
            :type :number
            :error error}))
       [["Ordered Not Invoiced" :notinvoiced]
        ["Here Barcode Missing" :barcode-missing]
        ["Here Barcode Not Scanning" :barcode-not-scanning]
        ["Here Barcode Incorrect" :barcode-incorrect]
        ["Here Damaged" :damaged]
        ["Here Incorrect Product" :incorrect-product]
        ["Here Expired" :expired]
        ["Missing" :missing]
        ["Here Expiring Soon" :expiring]
        ["Here No Packaging" :nopackaging]])]))

(defmethod grid/action :receiving/save-missing-items [app-atom {:keys [item]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [items session-id]} (get-in @app-atom [:receiving])]
    (comms/send :receiving/save-missing-items
      {:item item
       :items items
       :session-id session-id})))

(defmethod comms/receive :receiving/save-missing-items [app-atom e]
  (toaster/close-toast app-atom)
  (swap! app-atom assoc-in [:receiving :items] (:items e)))

(rum/defc missing-modal-footer < rum/reactive [app-atom config-atom]
  (let [{:keys [missing barcode-missing barcode-incorrect barcode-not-scanning expired damaged
                incorrect-product remaining expiring nopackaging] :as i}
        (cmn/curact config-atom [:config :item])]

    (grid/button-row
      {:left-text "Cancel"
       :left-no-icon true
       :left-fn #(grid/dispatch-modal-action app-atom :grid/single-input-modal-cancel)
       :right-text "Save"
       :right-no-icon true
       :right-fn
       (cond
         (or
           (> missing remaining)
           (> barcode-missing remaining)
           (> barcode-incorrect remaining)
           (> barcode-not-scanning remaining)
           (> expired remaining)
           (> damaged remaining)
           (> incorrect-product remaining)
           (> expiring remaining)
           (> nopackaging remaining))
         nil

         :else
         #(grid/dispatch-modal-action app-atom :receiving/save-missing-items {:item i}))})))

(defmethod grid/modal-config :receiving/missing-modal [_ _ _]
  {:body missing-modal-body
   :footer missing-modal-footer
   :modal-type :details})

(defn add-missing [items]
  (map
    #(let [remaining (- (:qty %) (:qtyscanned %))
           barcode-missing (trf/tonumber (:barcode-missing %))
           barcode-incorrect (trf/tonumber (:barcode-incorrect %))
           barcode-not-scanning (trf/tonumber (:barcode-not-scanning %))
           expired (trf/tonumber (:expired %))
           damaged (trf/tonumber (:damaged %))
           incorrect-product (trf/tonumber (:incorrect-product %))
           expiring (trf/tonumber (:expiring %))
           nopackaging (trf/tonumber (:nopackaging %))
           notreceivable
           (+ barcode-missing barcode-incorrect barcode-not-scanning expired damaged
             incorrect-product expiring nopackaging)
           saved? (boolean (:notreceivable %))]
       (assoc %
         :saved? saved?
         :notreceivable notreceivable
         :barcode-missing barcode-missing
         :barcode-incorrect barcode-incorrect
         :barcode-not-scanning barcode-not-scanning
         :expired expired
         :damaged damaged
         :incorrect-product incorrect-product
         :notinvoiced (trf/tonumber (:notinvoiced %))
         :missing (or (:missing %) (- remaining notreceivable))
         :expiring expiring
         :nopackaging nopackaging
         :remaining remaining))
    items))

(rum/defc review-missing < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        items (add-missing (cmn/curact current-atom :items))
        remaining-items (filter (comp pos? :remaining) items)
        notsaved (remove :saved? remaining-items)]

    (screen-wrapper app-atom {:modal-fn item-list-modal} ycs-steps :review-missing
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Set Reasons"
         [:span.u-hidden-from-view " - "]]]
       [:div.slats
        (map
          (fn [item]
            (rum/with-key
              (review-missing-slat item
                {:on-click
                 #(grid/multi-input-modal app-atom
                    {:title (str (keys @app-atom) "Missing Items")
                     :modal-type :receiving/missing-modal
                     :save-key :receiving/cancel-missing-items
                     :cancel-key :receiving/cancel-missing-items
                     :save-text "Save"
                     :item item})})
              (:barcode item)))
          remaining-items)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn (when (empty? notsaved) #(grid/dispatch-action app-atom :receiving/confirm {}))
         :right-style :call-to-action
         :right-text "Confirm"}))))

(defmethod flow/render-screen :receiving/review-missing [app-atom screen]
  (review-missing app-atom))

;; --- Blind Receiving: Discrepancy Screen ---

(def blind-discrepancy-reasons
  [["Received Damaged" "Here Damaged"]
   ["Damaged in Transit" "Damaged in Transit"]
   ["Expired Goods" "Here Expired"]])

(def blind-reason-labels
  {"Here Damaged" "Received Damaged"
   "Damaged in Transit" "Damaged in Transit"
   "Here Expired" "Expired Goods"})

(rum/defc blind-discrepancy-slat < rum/reactive
  [{:keys [barcode product code qty reason]} {:keys [on-click]}]
  [:article.slat.product-slat.transfer-product-slat
   {:class (u/bem :slat [:warning :warning-bg]) :on-click on-click}
   [:div.product-slat__qty.transfer-product-slat__qty
    [[:div.transfer-product-slat__count
      [:b qty]]]]
   [:div.product-slat__info
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h1.product-slat__title product]]]
    [:ul.product-slat__details
     [:li.product-slat__barcode
      [:b.u-text-spaced-1 barcode]]
     [:li.product-slat__barcode
      [:b.u-text-spaced-1 code]]]
    [:ul.product-slat__details
     [:li.product-slat__barcode
      [:b.u-text-status-negative (get blind-reason-labels reason reason)]]]]])

(defn blind-discrepancy-remaining-qty
  "Units of the scanned item not yet reported: scanned minus already reported for that barcode."
  [app-atom]
  (let [{:keys [barcode qtyscanned]} (cmn/curact app-atom [:receiving :blind-discrepancy-scan-item])
        reported
        (->>
          (cmn/curact app-atom [:receiving :blind-discrepancy-items])
          (filter #(= barcode (:barcode %)))
          (map :qty)
          (reduce + 0))]
    (- (or qtyscanned 0) reported)))

(rum/defc blind-discrepancy-modal-body < rum/reactive [app-atom config-atom]
  (let [{:keys [qty]} (cmn/curact config-atom [:config :item])
        {:keys [product barcode]} (cmn/curact app-atom [:receiving :blind-discrepancy-scan-item])
        remaining (blind-discrepancy-remaining-qty app-atom)
        over? (> (trf/tonumber qty) remaining)]
    [:div
     [:h3
      {:class (u/bem :heading [:medium-large])}
      "Damaged / Expired Item"]
     [:p
      {:class (u/bem :paragraph [:flush])}
      product
      [:br]
      [:b.u-text-spaced-1 barcode]]
     (forms/input "Qty:" "" (rum/cursor-in config-atom [:config :item :qty])
       {:type :number
        :hint (str "You scanned " remaining " that can still be reported")
        :error (when over? (str "Only " remaining " can be reported"))})
     [:div.form-field
      [:label.form-field__label "Reason:"]
      (forms/radios (rum/cursor-in config-atom [:config :item :reason])
        (map (fn [[label value]] {:label label :value value}) blind-discrepancy-reasons)
        {})]]))

(rum/defc blind-discrepancy-modal-footer < rum/reactive [app-atom config-atom]
  (let [{:keys [qty reason]} (cmn/curact config-atom [:config :item])
        qty (trf/tonumber qty)
        remaining (blind-discrepancy-remaining-qty app-atom)]
    (grid/button-row
      {:left-text "Cancel"
       :left-no-icon true
       :left-fn #(grid/dispatch-modal-action app-atom :grid/single-input-modal-cancel)
       :right-text "Add"
       :right-no-icon true
       :right-fn
       (when (and (pos? qty) (<= qty remaining) reason)
         #(grid/dispatch-modal-action app-atom :receiving/blind-add-discrepancy
            {:qty qty :reason reason}))})))

(defmethod grid/modal-config :receiving/blind-discrepancy-modal [_ _ _]
  {:body blind-discrepancy-modal-body
   :footer blind-discrepancy-modal-footer
   :modal-type :alert})

(defmethod grid/action :receiving/blind-add-discrepancy [app-atom {:keys [qty reason]} _]
  (let [scan-item (get-in @app-atom [:receiving :blind-discrepancy-scan-item])]
    (swap! app-atom update-in [:receiving :blind-discrepancy-items] conj
      (assoc scan-item :qty qty :reason reason))))

(defmethod flow/barcode-dispatch-screen :receiving/blind-discrepancy [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/blind-discrepancy-scan {:scan (str/trim scan)}))

(defmethod grid/action :receiving/blind-discrepancy-scan [app-atom {:keys [scan]} _]
  (let [items (get-in @app-atom [:receiving :items])
        item (first (filter #(= scan (:barcode %)) items))]
    (cond
      (nil? item)
      (toaster/open-toast app-atom :error "Item not found. Scan an item you received." {})

      :else
      (do
        (swap! app-atom assoc-in [:receiving :blind-discrepancy-scan-item] item)
        (if (pos? (blind-discrepancy-remaining-qty app-atom))
          (grid/multi-input-modal app-atom
            {:title "Damaged / Expired"
             :modal-type :receiving/blind-discrepancy-modal
             :save-key :receiving/blind-add-discrepancy
             :save-text "Add"
             :item {:qty 1 :reason nil}})
          (toaster/open-toast app-atom :error "Every scanned unit of this item is already reported." {}))))))

(defmethod grid/action :receiving/blind-discrepancy-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Enter barcode manually"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Look up"
     :save-key :receiving/blind-discrepancy-scan
     :input-key :scan
     :input-type :barcode}))

(defn blind-discrepancy-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :receiving/blind-discrepancy-menu-barcode}

      {:label "Cancel"
       :action :receiving/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :receiving/blind-save-and-confirm [app-atom]
  (let [discrepancy-items (get-in @app-atom [:receiving :blind-discrepancy-items])
        session-id (get-in @app-atom [:receiving :session-id])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :receiving/confirm
      {:session-id session-id
       :blind-discrepancy-items (or discrepancy-items [])})))

(defmethod comms/receive :receiving/blind-save-discrepancies [app-atom e]
  nil)

(rum/defc blind-discrepancy < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        discrepancy-items (or (cmn/curact current-atom :blind-discrepancy-items) [])
        stockorder (cmn/curact current-atom :stockorder)
        steps
        (if stockorder
          ycs-steps
          ibt-steps)]

    (screen-wrapper app-atom {:modal-fn blind-discrepancy-modal} steps :confirm
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Are any products damaged or expired?"
         [:span.u-hidden-from-view " - "]
         [:div
          [:span.heading__subtext "Scan an item to report damage or expiry"]
          (when (seq discrepancy-items)
            [:span.heading__subtext
             (str (count discrepancy-items) " item(s) reported")])]]]
       (if (empty? discrepancy-items)
         [:div.section
          [:div
           [:i.u-block-center
            {:class (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]
          [:p.u-text-center
           {:class (u/bem :paragraph [:flush])}
           "Scan damaged or expired items, or skip"]]
         [:div.slats
          (map
            (fn [i]
              (rum/with-key
                (blind-discrepancy-slat i {})
                (str (:barcode i) "-" (:reason i))))
            discrepancy-items)])]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text
         (if (seq discrepancy-items)
           "Next"
           "No Issues")
         :right-style :call-to-action
         :right-no-icon true
         :right-fn
         (if (seq discrepancy-items)
           #(t/transition-next app-atom :receiving/blind-manager-auth)
           #(grid/dispatch-action app-atom :receiving/blind-save-and-confirm {}))}))))

(defmethod flow/render-screen :receiving/blind-discrepancy [app-atom screen]
  (swap! app-atom update :receiving
    #(if (:blind-discrepancy-items %) % (assoc % :blind-discrepancy-items [])))
  (blind-discrepancy app-atom))

;; --- Blind Receiving: Manager Auth Screen ---

(defmethod flow/barcode-dispatch-screen :receiving/blind-manager-auth [_ app-atom scan]
  (grid/dispatch-action app-atom :receiving/blind-manager-scan {:scan scan}))

(defmethod grid/action :receiving/blind-manager-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/blind-manager-auth
    {:scan scan
     :session-id (get-in @app-atom [:receiving :session-id])}))

(defmethod comms/receive :receiving/blind-manager-auth [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (if (:authorized? e)
    (do
      (toaster/open-toast app-atom :success "Manager Authenticated." {})
      (grid/dispatch-action app-atom :receiving/blind-save-and-confirm {}))
    (toaster/open-toast app-atom :error (or (:message e) "Authorization failed") {})))

(rum/defc blind-manager-auth < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        stockorder (cmn/curact current-atom :stockorder)
        steps
        (if stockorder
          ycs-steps
          ibt-steps)]

    (screen-wrapper app-atom {} steps :confirm
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan manager tag to authorize"]
        [:div
         [:i.u-block-center
          {:class (u/bem :icon [:block :enormous :light-force :barcode-scan :2-1])}]]]
       [:div.section
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "A manager must authorize receiving with damaged or expired items"]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :receiving/blind-manager-auth [app-atom screen]
  (blind-manager-auth app-atom))

(rum/defc confirm < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:receiving])
        items (cmn/curact current-atom :items)
        itemqty (reduce + 0 (map :qty items))
        packeditemqty (reduce + 0 (map :qtyscanned items))
        remaining-items (filter #(> (:qty %) (:qtyscanned %)) items)
        remaining-itemqty (reduce + 0 (map :qty remaining-items))
        remaining-packeditemqty (reduce + 0 (map :qtyscanned remaining-items))
        stockorder? (cmn/curact current-atom :stockorder)
        steps
        (if stockorder?
          ycs-steps
          ibt-steps)]

    (screen-wrapper app-atom {} steps :confirm
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Confirm " (when (not (empty? remaining-items)) "Part ") "Fulfillment")]
        [:ul
         {:class (u/bem :order-calc [:fulfillment])}
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:truck :block])}]]
          [:span.order-calc__item-name "Items needed:"]
          [:span.order-calc__item-value [:b itemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :success :block])}]]
          [:span.order-calc__item-name "Items received:"]
          [:span.order-calc__item-value [:b.u-text-status-success packeditemqty]]]
         [:li.order-calc__item
          [:span.order-calc__item-icon-wrapper
           [:i {:class (u/bem :icon [:3-3 :error :block])}]]
          [:span.order-calc__item-name "Items not received:"]
          [:span.order-calc__item-value
           [:b.u-text-status-negative (- remaining-itemqty remaining-packeditemqty)]]]]]]

      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text
         (if (and stockorder? (not (empty? remaining-items)))
           "Review"
           "Confirm")
         :right-style :call-to-action
         :right-no-icon true
         :right-fn
         (if (and stockorder? (not (empty? remaining-items)))
           #(t/transition-next app-atom :receiving/review-missing)
           #(grid/dispatch-action app-atom :receiving/confirm {}))}))))

(defmethod flow/render-screen :receiving/confirm [app-atom screen]
  (confirm app-atom))

(defmethod grid/action :receiving/confirm [app-atom]
  (toaster/open-subtle-progress app-atom)
  (comms/send :receiving/confirm
    {:session-id (get-in @app-atom [:receiving :session-id])
     :missing-items
     (->>
       (get-in @app-atom [:receiving :items])
       add-missing
       (filter (comp pos? :remaining)))}))

(defmethod comms/receive :receiving/confirm [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :receiving/finished))

(rum/defc finished < rum/reactive [app-atom steps atom-key]
  (let [packbox-atom (rum/cursor-in app-atom [atom-key :packbox])
        stockorder-atom (rum/cursor-in app-atom [atom-key :stockorder])
        returncase-atom (rum/cursor-in app-atom [atom-key :returncase])
        rid (cmn/curact returncase-atom :refid)]

    (screen-wrapper app-atom {} steps :finished
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b "Thank you!"]]
        [:i.u-block-center
         {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
        [:div.u-margin-top-24
         [:p.u-text-center
          {:class (u/bem :paragraph [:flush :large])}
          [:b "Received and ready."]]
         [:p.u-text-center
          {:class (u/bem :paragraph [:flush])}
          [:span.u-hidden-from-view " "]
          [:span.u-block
           (or
             (cmn/curact packbox-atom :barcode)
             (when rid (str "YCR" rid))
             (str "YCS" (cmn/curact stockorder-atom :refid)))]]]]]

      []

      (grid/pos-call-to-action
        {:single-fn
         #(cond
            (cmn/curact app-atom [atom-key :packbox])
            (t/transition-next app-atom :receiving/packbox)

            (cmn/curact app-atom [atom-key :stockorder])
            (t/transition-next app-atom :receiving/stockorder)

            (cmn/curact app-atom [atom-key :returncase])
            (t/transition-next app-atom :aftersalesreceiving/printer))}))))

(defmethod flow/render-screen :receiving/finished [app-atom screen]
  (finished app-atom
    (if (get-in @app-atom [:receiving :stockorder])
      ycs-steps
      ibt-steps)
    :receiving))

(defmethod flow/render-screen :receiving/stockorder-details [app-atom screen]
  (prereceiving/stockorder-details
    (partial w/wrapper app-atom "Receiving")
    app-atom ycs-steps :receiving :receiving/stockorder-update-details))

(defmethod grid/action :receiving/stockorder-update-details [app-atom config _]
  (let [receiving-atom (rum/cursor app-atom :receiving)
        stockorder (cmn/curact receiving-atom :stockorder)
        es-client-order (cmn/curact receiving-atom :es-client-order)
        es-invoice (get (:invoice-details-idx es-client-order) (:supplierref stockorder))]
    (cond
      (or
        (nil? es-client-order)
        (and es-client-order es-invoice))
      (let [es-supplier-cost (trf/fromcurrency (:invoice-total-inc-tax es-invoice))]
        (toaster/open-toast app-atom :processing "Saving details" {})
        (comms/send :prereceiving/stockorder-update-details
          {:stockorder
           (u/maybe assoc
             stockorder
             :suppliercost (when (and es-client-order es-invoice) es-supplier-cost))
           :dispatch-key :receiving/location}))

      (and es-client-order (not es-invoice))
      (toaster/open-toast app-atom :error "Missing invoice from ES, please contact the ES team" {}))))
